// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  bankPaymentFormSchema,
  BankPaymentValuesType,
  bankPaymentInitialValues,
} from "./_formTypes";
import {
  GetBankPaymentRequest,
  useGetBankPayment,
  useCancelPaymentAndTransaction,
  CancelPaymentAndTransactionRequest,
  useRefundPaymentAndTransaction,
  RefundPaymentAndTransactionRequest,
  PagingResponse,
  useAuthorization,
  useGetMemberVPosList,
} from "../../../hooks";
import {
  GridColDef,
  GridActionsCellItem,
  GridValueFormatterParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  Link,
  Box,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
} from "@mui/material";
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  BankPaymentModal,
  DatePickerControl,
  DateTimePickerControl,
  Table,
  GetSettlementCompareDetailModal
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { useLocation, useNavigate } from "react-router-dom";
import BaseFilterTableWithAccordion from '../../atoms/BaseFilterTableWithAccordion';
import { BankFileStatusList } from "./BankFileStatusList";

export const BankPaymentComponent = () => {
  const theme = useTheme();

  const [showTable, setShowTable] = useState(false)
  const user = useLocation().state as unknown as IUser | undefined;
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<BankPaymentValuesType>({
      resolver: zodResolver(bankPaymentFormSchema),
      defaultValues: bankPaymentInitialValues,
    });
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const [getSettlementRow, setGetSettlementRow] = useState({} as any);
  const { mutate: GetBankPayment, isLoading: isGetBankPaymentLoading } =
    useGetBankPayment();

  const { mutate: getMemberVPosList, data: rawMemberVPosList } =
    useGetMemberVPosList();

  const [selectedMerchantVPosBankCode, setSelectedMerchantVPosBankCode] =
    useState(null as any);

  const setSnackbar = useSetSnackBar();

  const [userInfo] = useUserInfo();
  useEffect(() => {
    setValue("startDate", dayjs().add(-1, "day"));
    setValue("endDate", dayjs());
  }, [setValue]);

  const memberVPosList = useMemo(() => {
    return rawMemberVPosList?.data?.map(
      (memberVPos: { bankName: string; bankCode: string }) => {
        return {
          label: `${memberVPos.bankName}`,
          value: memberVPos.bankCode,
        };
      }
    );
  }, [rawMemberVPosList?.data]);
  const [formValues, setFormValues] = useState<BankPaymentValuesType | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const onSubmit = (data: BankPaymentValuesType) => {
    setTableData(undefined);
    setShowTable(true);
    setFilterAccordionExpand(false);

    const req: GetBankPaymentRequest = {
      date: data?.date ? dayjs(data.date).format("YYYY-MM-DD") : "",
      bankCode: data.bankCode, // Üye işyeri ID
      page: paginationModel.page,
      size: paginationModel.pageSize,
      orderByDesc: true, // Sipariş sırası
      orderBy: "CreateDate", // Siparişe göre
      //  status: data.status, // Durum
    };

    setFormValues(req);
    setIsSubmitted(true);

    // GetBankPayment(req, {
    //   onSuccess: (data) => {
    //     if (data.isSuccess) {
    //       setTableData(data.data);
    //       setFormValues(req);
    //       setIsSubmitted(true);

    //       setSnackbar({
    //         severity: "success",
    //         isOpen: true,
    //         description: data.message,
    //       });
    //     } else {
    //       setSnackbar({
    //         severity: "error",
    //         description: data.message,
    //         isOpen: true,
    //       });
    //     }
    //   },
    //   onError: () => {
    //     setSnackbar({
    //       severity: "error",
    //       description: "İşlem sırasında bir hata oluştu",
    //       isOpen: true,
    //     });
    //   },
    // });
  };

  useEffect(() => {
    if (!isSubmitted || !formValues) {
      return;
    }
    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    GetBankPayment(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [formValues, isSubmitted, queryOptions]);

  useEffect(() => {
    getMemberVPosList({
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "ACTIVE",
    });
  }, [getMemberVPosList]);

  function RenderActionButton(transaction: any) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal}
          text="Detay"
          sx={{ flex: 1, height: 20, py: 4 }}
        ></Button>
        <BankPaymentModal
          transaction={transaction}
          isOpen={isModalOpen}
          handleClose={handleCloseModal}
        />
      </>
    );
  }


  function GetSettlementCompare(transaction: any) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal}
          text="Fark Detay"
          sx={{ flex: 1, height: 20, py: 4 }}
        ></Button>
        <GetSettlementCompareDetailModal
          transaction={transaction}
          isOpen={isModalOpen}
          handleClose={handleCloseModal}
        />
      </>
    );
  }



  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );

  const getSettlementRowFnc = React.useCallback(
    (transaction: any) => () => {
      setGetSettlementRow(transaction);
    },
    []
  );




  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 200,
        getActions: (params) => {
          const actions = [];

          // Delete action
          if (showDelete) {
            actions.push(
              <GridActionsCellItem
                label="Sil"
                onClick={() => deleteRow(params.row)}
                icon={RenderActionButton(params.row)}
              />
            );
          }

          // Compare detail action
          const { compareDetail } = params.row;
          if (compareDetail?.auth?.ftpCount != compareDetail?.auth?.systemCount ||
            compareDetail?.refund?.ftpCount != compareDetail?.refund?.systemCount ||
            compareDetail?.void?.ftpCount != compareDetail?.void?.systemCount
          ) {
            actions.push(
              <GridActionsCellItem
                label="Fark Detay"
                onClick={() => getSettlementRowFnc(params.row)}
                icon={GetSettlementCompare(params.row)}
              />
            );
          }

          return actions;
        }
      },
      { field: "bankCode", headerName: "Banka Kodu", width: 180 },
      {
        field: "bankName",
        headerName: "Banka Adı",
        width: 300,
      },
      // -------------
      {
        field: 'authftpCount',
        headerName: "Banka İşlem Adet",
        width: 150,
        valueGetter: (params) => params?.row?.compareDetail?.auth?.ftpCount
      },
      {
        field: 'authsystemCount',
        headerName: "Sistem İşlem Adet",
        type: 'number',
        width: 150,
        valueGetter: (params) => params?.row?.compareDetail?.auth?.systemCount
      },
      {
        field: 'authftpGrossAmount',
        headerName: "Banka Toplam İşlem Tutar",
        type: 'decimal',
        width: 200,
        valueGetter: (params) => params?.row?.compareDetail?.auth?.ftpGrossAmount
      },
      {
        field: 'authsystemGrossAmount',
        headerName: "Sistem Toplam İşlem Tutar",
        type: 'decimal',
        width: 220,
        valueGetter: (params) => params?.row?.compareDetail?.auth?.systemGrossAmount
      },
      // ----------------
      {
        field: 'refundftpCount',
        headerName: "İade Banka İşlem Adet",
        width: 150,
        valueGetter: (params) => params?.row?.compareDetail?.refund?.ftpCount
      },
      {
        field: 'refundsystemCount',
        headerName: "İade Sistem İşlem Adet",
        type: 'number',
        width: 150,
        valueGetter: (params) => params?.row?.compareDetail?.refund?.systemCount
      },
      {
        field: 'refundftpGrossAmount',
        headerName: "İade Banka Toplam İşlem Tutar",
        type: 'decimal',
        width: 200,
        valueGetter: (params) => params?.row?.compareDetail?.refund?.ftpGrossAmount
      },
      {
        field: 'refundsystemGrossAmount',
        headerName: "İade Sistem Toplam İşlem Tutar",
        type: 'decimal',
        width: 220,
        valueGetter: (params) => params?.row?.compareDetail?.refund?.systemGrossAmount
      },
      {
        field: "brutTutar",
        headerName: "Brüt Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "totalBankCommissionAmount",
        headerName: "Toplam Banka Komisyon Tutarı",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "totalBankAmount",
        headerName: "Toplam Banka Tutarı",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "endOfDayDate",
        headerName: "Gün Sonu Tarih",
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<string>) => {
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // +1 çünkü aylar 0'dan başlar
          const year = date.getFullYear();

          return `${day}-${month}-${year}`;
        },
      },
    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const req: GetBankPaymentRequest = {
      date: getValues("date")
        ? dayjs(getValues("date")).format("YYYY-MM-DD")
        : "",
      bankCode: getValues("bankCode") ? getValues("bankCode") : "",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
    };

    GetBankPayment(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      bankCode: getValues("bankCode") ? getValues("bankCode") : "",
      date: dayjs(getValues("date")).format("YYYY-MM-DD"),
      ...getQueryParams(queryOptions),
    };


    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    GetBankPayment(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Banka Kodu": item?.bankCode,
                  "Banka Adı": item?.bankName,
                  "Brüt Tutar": item?.brutTutar,
                  "Toplam Banka Tutarı": item?.totalBankAmount,
                  "Toplam Banka Komisyon Tutarı": item?.totalBankCommissionAmount,
                  "Gün Sonu Tarih": item?.endOfDayDate
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Banka Hak Ediş Raporları");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasLoading = isGetBankPaymentLoading;

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [fileStatusFilters, setFileStatusFilters] = useState<{ date?: string; bankCode?: string } | null>(null);
  const [shouldFetchFileStatus, setShouldFetchFileStatus] = useState(false);
  const [isFileStatusModalOpen, setIsFileStatusModalOpen] = useState(false);

  const handleOpenStatusModal = () => {
      const data = getValues();
      setFileStatusFilters({
          date: data.date ? dayjs(data.date).format("YYYY-MM-DD") : undefined,
          bankCode: data.bankCode
      });
      setShouldFetchFileStatus(true);
      setIsFileStatusModalOpen(true);
  };

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <BaseFilterTableWithAccordion summary="Banka Hak Ediş Raporları" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={5}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              >
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <DatePickerControl
                    sx={{ flex: 1, ml: isDesktop ? 0 : 0 }}
                    id="date"
                    control={control}
                    label="Gün Sonu tarihi"
                    defaultValue={dayjs()}
                  />
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  {memberVPosList ? (
                    <Controller
                      control={control}
                      name="bankCode"
                      render={({ field }) => {
                        // Add this line
                        return (
                          <>
                            <Autocomplete
                              sx={{ mr: isDesktop ? 3 : 0 }}
                              onChange={(event, selectedValue) => {
                                setSelectedMerchantVPosBankCode(selectedValue);
                                field.onChange(selectedValue?.value); // Add this line
                              }}
                              id="bankCode"
                              options={memberVPosList}
                              value={selectedMerchantVPosBankCode}
                              getOptionLabel={(option: {
                                label: string;
                                value: string;
                              }) => option.label}
                              renderInput={(params) => (
                                <TextField {...params} label="Banka" />
                              )}
                            />
                          </>
                        );
                      }}
                    />
                  ) : null}
                </FormControl>
              </Stack>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? 800 : "auto"}
              ></Stack>

              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? 780 : "auto"}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />

          <BankFileStatusList 
            filters={fileStatusFilters} 
            shouldFetch={shouldFetchFileStatus} 
            open={isFileStatusModalOpen}
            onClose={() => setIsFileStatusModalOpen(false)}
          />

          <Stack flex={1} mt={2}>
            {showTable && (
              <>
                <Table
                  columnVisibilityConfigKey="bankPaymentReportColumnVisibilityKey"
                  handleFilterChange={handleFilterChange}
                  hasActiveFilters={hasActiveFilters}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems ?? 0}
                  extraToolbarButton={
                    <Button
                        onClick={handleOpenStatusModal}
                        variant="outlined"
                        startIcon={<PointOfSaleIcon />}
                        sx={{ marginLeft: 2 }}
                        text="DOSYA DURUMLARI"
                    />
                  }
                  isRowSelectable={() => false}
                  // disableColumnMenu  
                  rows={tableData?.result ?? []}
                  autoHeight={!isDesktop}
                  columns={columns}
                  exportFileName="Ödeme ve İslem Raporu"
                  onSave={() => onSave()}
                  getRowClassName={(params) => {
                    const { compareDetail } = params.row;
                    if (compareDetail?.auth?.ftpCount != compareDetail?.auth?.systemCount ||
                      compareDetail?.refund?.ftpCount != compareDetail?.refund?.systemCount ||
                      compareDetail?.void?.ftpCount != compareDetail?.void?.systemCount
                    ) {
                      return 'unmatched-settlement-row';
                    }
                    return 'BLOCKED';
                  }}
                />
              </>
            )}
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
